class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');

      if(this.input) {
        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
          }, 300).bind(this));
      }
      if(this.input && this.input.value.length > 0) {
        this.onChange();
      }
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      // fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options]&resources[options][fields]=title,tag,product_type,variants.title&section_id=predictive-search`)
      fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,collection&resources[limit]=3&resources[limit_scope]=each&resources[options][unavailable_products]=hide&resources[options]&resources[options][fields]=title,tag,product_type,variants.title&section_id=predictive-search`)


        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  